import React,{useState, useEffect} from 'react';
import { Navbar, Nav, Container, InputGroup, Button, FormControl, ButtonGroup, ToggleButton} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFeather, faCircleNotch, faHandPaper, faEye } from '@fortawesome/free-solid-svg-icons';
import Card from '../card';
import FlipCard from '../flipcard';
import Deck from '../deck';
import Note from '../note';
import Draggable, {DraggableCore}  from 'react-draggable';
import { isMobile, isIOS } from 'react-device-detect';
import { useLanguage } from '../../i18n/LanguageContext';

function Free(props) {
  const { t } = useLanguage();
  const containerRef = React.useRef();

  var count = 0;

  if (props.cards){
    count = props.cards.length;
  }
  const [shuffle, setShuffle] = useState(false);
  const [currentCard, setCard] = useState(null);
  const [currentCards, setCards] = useState([]);
  const [draggable, setDraggable] = useState([]);
  const [move, setMove] = useState(true);
  const [manual, setManual] = useState(false);
  const [updated, setUpdate] = useState(false);
  const [currentTitle, setTitle] = useState("");
  const [show, setShow] = useState(false);
  const [showSaved, setShowSaved] = useState(props.cards != null);
  const [saved, setSaved] = useState(props.cards);
  const [showNote, setShowNote] = useState(false);
  const [availableCards, setAvailableCards] = useState(3);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);

  const rotation = () => {
    var prevHeight = height;
    var prevWidth = width;
    //Need to get the cards extent...
    var minX = 0, minY = 0, maxX = 0, maxY = 0;

    currentCards.forEach(function(c){
      if (c.x < minX){
        minX = c.x;
      }

      if (c.y < minY){
        minY = c.y;
      }

      if (c.x + 200 > maxX){
        maxX = c.x + 200;
      }

      if (c.y + 250 > maxY){
        maxY = c.y + 250;
      }
    });

    var spreadHeight = maxY - minY;
    var spreadWidth = maxX - minX;

    var w = prevHeight;
    var h = prevWidth;

    if (spreadHeight > h){
      h = spreadHeight;
    }

    if (spreadWidth > w){
      w = spreadWidth;
    }

    setWidth(w);
    setHeight(h);
  }

  useEffect(() => {
    
    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotation);
      }
      else{
        window.addEventListener("orientationchange", rotation);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }
    
    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotation);
        }
        else{
          window.removeEventListener("orientationchange", rotation);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 
    
  },[]);

  const updateDimensions = () => {
    //Need to get the cards extent...
    var minX = 0, minY = 0, maxX = 0, maxY = 0;

    currentCards.forEach(function(c){
      if (c.x < minX){
        minX = c.x;
      }

      if (c.y < minY){
        minY = c.y;
      }

      if (c.x + 200 > maxX){
        maxX = c.x + 200;
      }

      if (c.y + 250 > maxY){
        maxY = c.y + 250;
      }
    });

    var spreadHeight = maxY - minY;
    var spreadWidth = maxX - minX;

    var w = window.outerWidth;
    var h = window.outerHeight;

    if (spreadHeight > h){
      h = spreadHeight;
    }

    if (spreadWidth > w){
      w = spreadWidth;
    }

    setWidth(w);
    setHeight(h);
  }
 
  //generate a new random card on start
  useEffect(() => {
    var cards = [];
    if (currentCards.length == 0){
      if (props.cards){
        cards = props.cards.cards
        setAvailableCards(cards.length);
        setMove(false);
      }
      else{
        cards = getRandomKeys(availableCards);
      }
      setCards(cards);
    }

    window.addEventListener("resize", updateDimensions);
    if (isIOS){
      window.addEventListener("orientationchange", updateDimensions);
    }
    return function(){
      window.removeEventListener("resize", updateDimensions);
      if (isIOS){
        window.removeEventListener("orientationchange", updateDimensions);
      }
    } 
  },[currentCards] );
  

  function getRandomKeys(count){
    var cards = [];
    for (var i=0;i<count;i++){
      var key = getRandomKey(cards);
      cards.push({card:key, x:0, y:0});
      draggable[i]="true";
    }
    return cards;
  }

  function getKey(){
    var key;
    for (var i=0; i<11; i++){
      key = (Math.floor(Math.random() * 108) + 1).toString();
    }
    return key;
  }

  function getRandomKey(cards){
    var key = getKey();
    var existingKeys = cards.map(function(c){
      return c.card;
    });
    if (existingKeys.indexOf(key)>=0){
      return getRandomKey(cards);
    }
    else{
      return key;
    }
  }

  function handleClick(card, flipped){
    var key;
    if (flipped){
      //Click on card, show commentary
      setCard(card);
      handleShow();
    }
    else{
      setShowSaved(true);
    }
  }

  function handleSelect(action){
    if (action == "new"){
      setCards(getRandomKeys(availableCards));
      setSaved(null);
      setTimeout(function(){
        setShuffle(true);
        setMove(true);
        setManual(false);
      },500)
    
      setShowSaved(false);
    }
    else if(action == "save"){
      setShowNote(true);
    }
    else if(action == "back"){
      props.onBackSelected();
    }
  }
  
  function handleNoteClose(saved, cards){
    setShowNote(false)
    if (saved){
      setSaved(cards);
    }
  }

  function getNote(){
    if (saved){
      return saved.note;
    }
    else{
      return "";
    }
  }

  function handleDrag(index, { translateX, translateY}){
      draggable[index] = "true";
  }

  function handleDragEnd(index, e){
   
    var t = containerRef.current.children[index + 1].attributes["style"].value;
   
    //Parse transform
    var startPos = t.indexOf('(');
    var endPos = t.indexOf(')');
    var pos = t.substring(startPos + 1,endPos);
    var coords = pos.split(',');
    currentCards[index].x = parseInt(coords[0].replace('px',''));
    currentCards[index].y = parseInt(coords[1].replace('px',''));

    if (isMobile){
      if (draggable[index] == "true"){
        draggable[index] = "false";
      }
    }
    else{
      //Desktop browser
      if (draggable[index] == "true"){
          draggable[index] = "stop";
      }
      else if (draggable[index] == "stop"){
        draggable[index] = "false";
      }
    }
  
    var cardsMoved = getCardsMoved();

    if (draggable[index] == "false" && cardsMoved == currentCards.length){
      //change into viewing mode only if cards are not flipped
      if (!showSaved && manual == false){
        setMove(false);
      }
    }

    setUpdate(!updated);
    
    
  }

  function getCardsMoved(){
    var cardsMoved = 0;
    currentCards.forEach(function(c){
      if ((c.x != null && c.y !== null) && (c.x == 0 && c.y == 0)){
        //Not moved
      }
      else{
        //moved
        cardsMoved ++;
      }
    });
    return cardsMoved;
  }

  function getDraggableCards(){
    //Count how many cards on canvas
    var h; 
    var w;

    if (availableCards > 11){
      w = 'min(calc(18vmin), 100px)';
      h = 'min(calc(18vmin*1.3), calc(100px*1.3)';
    }
    else if (availableCards > 9){
      w = 'min(calc(21vmin), 120px)';
      h = 'min(calc(21vmin*1.3), calc(120px*1.3)';
    }
    else if (availableCards > 7){
      w = 'min(calc(23vmin), 130px)';
      h = 'min(calc(23vmin*1.3), calc(130px*1.3)';
    }
    else if (availableCards > 5){
      w = 'min(calc(25vmin), 140px)';
      h = 'min(calc(25vmin*1.3), calc(140px*1.3)';
    }
    else if (availableCards > 3){
      w =  'min(calc(27vmin), 160px)';
      h = 'min(calc(27vmin*1.3), calc(160px*1.3)';
    }
    else if (availableCards > 2){
      w =  'min(calc(28vmin), 170px)';
      h = 'min(calc(28vmin*1.3), calc(170px*1.3)';
    }
    else if (availableCards > 1){
      w =  'min(calc(32vmin), 190px)';
      h = 'min(calc(32vmin*1.3), calc(190px*1.3)';
    }
    else if (availableCards == 1){
      w =  'min(calc(50vmin), 220px)';
      h = 'min(calc(50vmin*1.3), calc(220px*1.3)';
    }
   
    var cards = currentCards.map(function(c,i){
      
      if (draggable[i] == null){
        draggable[i] = "true";
      }

     // var cardsMoved = getCardsMoved();
      var disabled = !move;//(draggable[i]=="false") && (cardsMoved == currentCards.length);
      
      if (props.cards){
       
        return(
          <Draggable disabled={disabled} defaultPosition={{x: c.x, y: c.y}} grid={[10, 10]} onDrag={handleDrag.bind(this,i)} onStop={handleDragEnd.bind(this,i)}>
          <div>
            <FlipCard onClick={handleClick.bind(this,c.card)} card={c.card} flipped={props.cards != null} width={w} height={h} draggable={!disabled} index={i}></FlipCard>
          </div>
          </Draggable>
        );
      }
      else{
        var x = i * 4;
        var y = 0;
        
        return (
          <Draggable disabled={disabled} defaultPosition={{x: x, y: y}} grid={[10, 10]} onDrag={handleDrag.bind(this,i)} onStop={handleDragEnd.bind(this,i)}>
            <div><FlipCard onClick={handleClick.bind(this,c.card)} card={c.card} flipped={props.cards != null} height={h} width={w} draggable={!disabled} index={i}></FlipCard></div>
          </Draggable>
        )
      }
     
       
    });

    return cards;
  }

  function getDeck(){
    if (shuffle){
      setTimeout(function(){
        setShuffle(false);
      },1500)
      
    var cardWidth = 'min(calc(40vmin),200px)';
    var cardHeight = 'min(calc(40vmin * 1.3),calc(200px * 1.3))';

      return (
        
        <div>
          <Deck width={cardWidth} height={cardHeight}/>
        </div>
      )
    }
    else{
      return getDraggableCards();
    }
  }

  function onIncrease(){
    if (availableCards < 12){
      setMove(true);
      setAvailableCards(availableCards + 1);
      var key = getRandomKey(currentCards);
      var cards = currentCards;
      cards.push({card:key, x:0, y:0});
      setCards(cards);
    }
    
  }

  function onDecrease(){
    if (availableCards > 1){
      setMove(true);
      setAvailableCards(availableCards - 1)
      var cards = currentCards;
      cards.splice(currentCards.length-1,1);
      setCards(cards);
    }
  }

  function getTitle(){
    if(saved){
      return saved.title
    }
    else{
      var cards = currentCards.map(function(c,i){
        return c.card;
      })
      return t('spreads.free.title') + " " + cards.join(',');
    }
  }

  function getChecked(btn){
    if (btn == "layout"){
      return move;
    }
    else if(btn == "viewing"){
      return !move;
    }
  }

  function handleMode(btn){
    if (manual == false){
      setManual(true);
    }
    if(btn == "layout"){
      setMove(true);
    }
    else if(btn == "viewing"){
      setMove(false);
    }
  }

  var saveNote = t('common.saveNotes');
  if (saved){
    saveNote = t('common.notes');
  }

  var time = "";
  if (props.cards){
    time = props.cards.time;
  }

  const radios = [
    { name: t('freeSpread.layout'), icon:faHandPaper, value: 'layout' },
    { name: t('freeSpread.viewing'), icon:faEye , value: 'viewing' },
  ];
  return (
    <div id="container">
      <Navbar fixed="top" bg={props.theme} variant={props.theme} style={{width: "100%", paddingBottom:0, paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
        <Nav fill style={{width: "100%"}} className="justify-content-center"  onSelect={handleSelect}>
          <Nav.Link eventKey="back" style={{textAlign: "left", marginLeft:"10px",}}><span aria-hidden="true" class="carousel-control-prev-icon" style={{verticalAlign:'middle'}} onTouchEnd={handleSelect.bind(this, "back")}/></Nav.Link>
          <Nav.Link eventKey="back" hidden={props.cards == null}><span style={{verticalAlign:'middle'}}>{time}</span></Nav.Link>
          <Nav.Link eventKey="new" hidden={props.cards != null}><span style={{verticalAlign:'middle'}}><FontAwesomeIcon icon={faCircleNotch}  size='1x' /> {t('common.shuffle')}</span></Nav.Link>
          <Nav.Link eventKey="save" hidden={!showSaved}><span style={{verticalAlign:'middle'}}><FontAwesomeIcon icon={faFeather}  size='1x' />{saveNote}</span></Nav.Link>
        </Nav>
      </Navbar>
        <Container fluid style={{overflow:'auto', paddingTop:'75px',paddingBottom:'85px'}}>
          <div ref={containerRef} style={{position:'relative',  width:'100%', height:height}}>
            <div style={{float:'right'}}> 
            <div style={{paddingTop:10}}>
              <InputGroup hidden={props.cards != null} style={{width:'110px'}} size="md" className="mb-3 mx-auto">
                <Button variant="outline-secondary" onClick={onDecrease}>-</Button>
                <FormControl value={availableCards} type="number" readOnly/>
                <Button variant="outline-secondary" onClick={onIncrease}>+</Button>
              </InputGroup>
              <div className="d-flex flex-wrap justify-content-end">
              <ButtonGroup className="mb-2" size="md" vertical={true} style={{right:0}}>
                {radios.map((radio, idx) => (
                  <ToggleButton
                    key={idx}
                    id={`mode-${idx}`}
                    type="radio"
                    name="mode"
                    variant="secondary"
                    value={radio.value}
                    checked={getChecked(radio.value)}
                    onChange={(e) => handleMode(e.currentTarget.value)}
                  >
                    <FontAwesomeIcon icon={radio.icon}  size='1x' />
                  </ToggleButton>
                ))}
              </ButtonGroup>
              </div>
            </div>
            </div>
            {getDeck()}
          </div>
        </Container>
      <Card card={currentCard} show={show} placement="bottom" name="bottom" onHide={handleClose} ></Card>
      <Note className="saveCardDialog" cards={currentCards} title={getTitle()} saved={saved} type="free" show={showNote} onHide={handleNoteClose}></Note>
    </div>
  )
};

export default Free;